module.exports = __webpack_public_path__ + "img/pinwall-logo-mobile - Copy.fd7ecaf5.svg";